import React from 'react';
import { Helmet } from 'react-helmet';
import useToggle from '../../Hooks/useToggle';
import BackToTop from '../BackToTop';
import FooterHomeOne from '../Footer/FooterHomeThree';
import HeaderNews from '../Header/HeaderNews';
import HeroNews from '../Header/HeroNews';
import Drawer from '../Mobile/Drawer';
import Forms from './Forms';

function Contact() {
    const [drawer, drawerAction] = useToggle(false);

    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content="Contact us to learn more about our OTO Software Suite for inventory management, financing, POS, and hotel management in Kigali, Rwanda. Request a demo, inquire about our services, or get answers to your questions. We're here to help you succeed!"
                />
                <title>Contact Us for Demo and Inquiries | OTO Software Suite"</title>
            </Helmet>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderNews drawer={drawer} action={drawerAction.toggle} />
            <HeroNews
                title="Contact Us"
                breadcrumb={[
                    { link: '/', title: 'Home' },
                    { link: '/contact', title: 'Contact' },
                ]}
            />
            <Forms />
            <FooterHomeOne />
            <BackToTop />
        </>
    );
}

export default Contact;
